import { Link } from 'react-router-dom';

export default function AcceptableUsePage() {
  return (
    <div className="min-h-screen bg-surface-900 text-surface-200">
      <div className="max-w-3xl mx-auto px-6 py-12">
        <Link to="/" className="text-brand-400 text-sm hover:underline mb-8 inline-block">&larr; Back to AutoCarPost</Link>
        <h1 className="text-3xl font-bold text-white mb-2">Acceptable Use Policy</h1>
        <p className="text-surface-500 text-sm mb-8">Last updated: {new Date().toLocaleDateString('en-US', { month: 'long', day: 'numeric', year: 'numeric' })}</p>

        <div className="space-y-8 text-surface-300 text-sm leading-relaxed">
          <section>
            <h2 className="text-lg font-semibold text-white mb-3">1. Purpose</h2>
            <p>This Acceptable Use Policy outlines the rules and guidelines for using AutoCarPost. All users must comply with this policy. Violations may result in account suspension or termination.</p>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-white mb-3">2. Prohibited Listings</h2>
            <p>You may not list or advertise:</p>
            <ul className="list-disc ml-6 mt-2 space-y-1">
              <li>Stolen vehicles or vehicles with undisclosed salvage titles</li>
              <li>Vehicles with tampered odometers</li>
              <li>Vehicles with undisclosed liens or encumbrances</li>
              <li>Vehicles you do not own or have authority to sell</li>
              <li>Non-existent vehicles (phantom listings)</li>
              <li>Vehicles that do not match the provided VIN</li>
              <li>Parts, accessories, or non-vehicle items (vehicle listings only)</li>
            </ul>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-white mb-3">3. Photo Requirements</h2>
            <ul className="list-disc ml-6 space-y-1">
              <li>Photos must be of the actual vehicle being listed</li>
              <li>You must own the rights to all photos uploaded</li>
              <li>Stock photos or photos from other listings are not permitted</li>
              <li>Photos must not contain watermarks from other platforms</li>
              <li>Photos must not contain obscene, offensive, or inappropriate content</li>
            </ul>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-white mb-3">4. Listing Accuracy</h2>
            <ul className="list-disc ml-6 space-y-1">
              <li>All vehicle details must be accurate to the best of your knowledge</li>
              <li>Known defects, damage, or mechanical issues must be disclosed</li>
              <li>Pricing must reflect the actual asking price (no bait-and-switch)</li>
              <li>Mileage must be accurately reported</li>
              <li>Condition ratings must honestly reflect the vehicle's state</li>
            </ul>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-white mb-3">5. Prohibited Conduct</h2>
            <p>Users may not:</p>
            <ul className="list-disc ml-6 mt-2 space-y-1">
              <li>Create multiple accounts to circumvent vehicle limits or bans</li>
              <li>Use the Service for any unlawful purpose</li>
              <li>Engage in discriminatory practices in vehicle sales</li>
              <li>Harass, threaten, or abuse other users</li>
              <li>Attempt to access other users' accounts or data</li>
              <li>Use automated tools to scrape data or create listings</li>
              <li>Interfere with or disrupt the Service's infrastructure</li>
              <li>Circumvent rate limits, security measures, or access controls</li>
            </ul>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-white mb-3">6. Dealer-Specific Rules</h2>
            <p>Dealer account holders must additionally:</p>
            <ul className="list-disc ml-6 mt-2 space-y-1">
              <li>Hold a valid dealer license in their operating state</li>
              <li>Comply with all applicable federal and state regulations (FTC Used Car Rule, state lemon laws, etc.)</li>
              <li>Provide accurate business information</li>
              <li>Respond to buyer inquiries in a timely manner</li>
            </ul>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-white mb-3">7. Reporting Violations</h2>
            <p>If you encounter a listing or user that violates this policy, please report it to <a href="mailto:abuse@autocarpost.com" className="text-brand-400 hover:underline">abuse@autocarpost.com</a> with details of the violation. We will investigate and take appropriate action.</p>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-white mb-3">8. Enforcement</h2>
            <p>Violations of this policy may result in:</p>
            <ul className="list-disc ml-6 mt-2 space-y-1">
              <li>Removal of individual listings</li>
              <li>Temporary account suspension</li>
              <li>Permanent account termination</li>
              <li>Reporting to law enforcement (for criminal activity)</li>
            </ul>
            <p className="mt-2">We reserve the right to take action at our sole discretion. Repeated or severe violations will result in immediate account termination without prior warning.</p>
          </section>
        </div>

        <div className="mt-12 pt-8 border-t border-surface-800 flex gap-6 text-xs text-surface-500">
          <Link to="/terms" className="hover:text-brand-400">Terms of Service</Link>
          <Link to="/privacy" className="hover:text-brand-400">Privacy Policy</Link>
        </div>
      </div>
    </div>
  );
}
